import { render, staticRenderFns } from "./ArticleCard.vue?vue&type=template&id=99a63328&scoped=true"
import script from "./ArticleCard.vue?vue&type=script&lang=js"
export * from "./ArticleCard.vue?vue&type=script&lang=js"
import style0 from "./ArticleCard.vue?vue&type=style&index=0&id=99a63328&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a63328",
  null
  
)

export default component.exports